module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy_bg-5157000f841884c0d38a56ea2af97aed.png";